import type { LayoutLoad } from "./$types";

import type {
  Announcement,
  Event,
  HeraldPage,
  Map,
  Page,
  Place,
  PlaceHoursGroup,
  PlaceType,
  Schedule
} from "../types";
import { request } from "../data/client";
import { BigGulpQuery } from "../data/big-gulp";

export const load: LayoutLoad = async function ({ data, url, fetch }) {
  const {
    announcements,
    events,
    heraldHomePage,
    heraldMap,
    heraldPages,
    heraldSchedule,
    placeHoursGroups,
    placeTypes,
    places
  } = await request(fetch, {
    url,
    query: BigGulpQuery
  });

  return {
    ...data,
    now: new Date(),
    announcements: announcements as Announcement[],
    events: events as Event[],
    heraldHomePage: heraldHomePage as Page,
    heraldMap: heraldMap as Map,
    heraldPages: heraldPages as HeraldPage[],
    heraldSchedule: heraldSchedule as Schedule,
    placeHoursGroups: placeHoursGroups as PlaceHoursGroup[],
    placeTypes: placeTypes as PlaceType[],
    places: places as Place[]
  };
};
